var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 11334",
    transform: "translate(867.671 175.671)",
    fill: "#3b5175",
    stroke: "#707070",
    d: "M0 0h24v24H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 149",
    transform: "translate(-867.671 -175.671)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 11333",
    fill: "none",
    d: "M867.671 175.671h24v24h-24z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14933",
    d: "M886 189.617a3.8 3.8 0 0 0-3.067 1.509l-6.718-2.872a2.385 2.385 0 0 0 .049-.584 2.385 2.385 0 0 0-.049-.584l6.718-2.869a3.8 3.8 0 0 0 3.067 1.509 3.895 3.895 0 1 0-3.895-3.898 2.385 2.385 0 0 0 .049.584l-6.718 2.873a3.8 3.8 0 0 0-3.067-1.509 3.895 3.895 0 1 0 0 7.789 3.8 3.8 0 0 0 3.067-1.509l6.718 2.872a2.385 2.385 0 0 0-.049.584 3.895 3.895 0 1 0 3.895-3.895Zm0-9.737a1.947 1.947 0 1 1-1.947 1.947 1.947 1.947 0 0 1 1.947-1.946Zm-13.631 9.737a1.947 1.947 0 1 1 1.947-1.947 1.947 1.947 0 0 1-1.947 1.947ZM886 195.459a1.947 1.947 0 1 1 1.945-1.942 1.947 1.947 0 0 1-1.945 1.942Z",
    fill: "#3b5175"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareDashboard);
export default __webpack_public_path__ + "static/media/Share_Dashboard.61358290ba873cbedfbf0e71152934e0.svg";
export { ForwardRef as ReactComponent };